import React 			from 'react';
import PropTypes 		from 'prop-types';
import BLComponent 		from '../../../core/_BLComponent.jsx';

export default function SeriesSixGuidelines(date) {
	return [
			{
					id: 0
				,	title: 'Digital building'
				,	allOpen: false
				, items: [
						{
							id: 0
						,	open: false
						,	question: "Designing in Studio"
						,	answer: `<p>You will be required to build your design in Studio and upload a .io Studio file for your submission.</p>
						<div class="crowd-resource-box">
							<p class="crowd-resource-box__label"><i class="far fa-link fa-fw l-margin-right--sm"></i>Resources</p>
							<div class="crowd-resource-box__items">
								<a href="${blapp.url2.getStudioDownloadUrl()}" target="_blank" class="btn crowd-resource-box__item">Download Studio<i class="far fa-square-arrow-up-right l-margin-left--sm"></i></a>
								<a href="https://studiohelp.bricklink.com/hc/en-us" target="_blank" class="btn crowd-resource-box__item">Studio Help Center<i class="far fa-square-arrow-up-right l-margin-left--sm"></i></a>
								<a href="https://forum.bricklink.com/viewforum.php?f=13&sid=275872312bdb877b1372a3ec3a8d56d7" class="btn crowd-resource-box__item" target="_blank">BDP Studio Forum<i class="far fa-square-arrow-up-right l-margin-left--sm"></i></a>
							</div>
						</div>`
						}
					, {
							id: 1
						,	open: false
						, urlHash: 'studio'
						,	question: "File set-up for BDP"
						,	answer: `<p>Set your Studio file up for success when designing for BDP by doing the following:</p>
						<ol>
							<li>
								<p>Build your creations using the current BDP Series Palette.</p>
								<div class="crowd-guidelines-image">
									<img src="//${blapp.config.getHost( "static2" )}/img/bdp/series-1-images/file-setup/digital-building_step-1_bdp-palette@2x.png" style="width:246px"/>
								</div>
								<p class="l-margin-bottom text--medium">Note that the current BDP Series Palette elements may be subject to change.</p>
								<div class="crowd-tip-box">
									<p class="crowd-tip-box__label"><i class="fa-light fa-sparkles fa-fw l-margin-right--sm"></i>Tips</p>
									<div class="crowd-tip-box__items">
										<p>Get to know the dedicated BDP palette of elements before you start building. Make this palette the foundation of your creative efforts and use it to its fullest extent.</p>
									</div>
								</div>
							</li>
							<li>
								<p>Turn on the Color Palette Filter and select the “within the selected palette” option.</p>
								<div class="crowd-guidelines-image">
									<img src="//${blapp.config.getHost( "static2" )}/img/bdp/series-1-images/file-setup/digital-building_step-2_color-palette@2x.png"/>
								</div>
							</li>
							<li>
								<p>Turn on the Collision feature by clicking on the icon in the top tool bar until it turns red.</p>
								<div class="crowd-guidelines-image">
									<img src="//${blapp.config.getHost( "static2" )}/img/bdp/series-1-images/file-setup/digital-building_step-3_collision@2x.png" style="width:252px"/>
								</div>
							</li>
							<li>
								<p>Turn on the Snap feature by clicking on the icon in the top tool bar until it turns Blue.</p>
								<div class="crowd-guidelines-image">
									<img src="//${blapp.config.getHost( "static2" )}/img/bdp/series-1-images/file-setup/digital-building_step-4_snap@2x.png" style="width:252px"/>
								</div>
							</li>
							<li>
								<p>Select the grid size that works for you by clicking on the icon in the top tool bar menu and choosing one of the three options in the dropdown.</p>
								<div class="crowd-guidelines-image">
									<img src="//${blapp.config.getHost( "static2" )}/img/bdp/series-1-images/file-setup/digital-building_step-5_grid@2x.png" style="width:260px"/>
								</div>
							</li>
							<li>
								<p>Periodically check the model stability. To do this, turn on the Stability feature by clicking on the icon in the top tool bar until it turns blue. Use this tool to check hinge elements and any tall or intricate areas.</p>
							</li>
							<li>
								<p>Periodically validate your parts list. To do this, turn on the Step List Part Filter and select “unavailable parts.” Use this tool to check if you have any invalid parts in your creation.</p>
								<div class="crowd-guidelines-image">
									<img src="//${blapp.config.getHost( "static2" )}/img/bdp/series-1-images/file-setup/digital-building_step-7_step-list@2x.png" style="width:256px"/>
								</div>
							</li>
							<li>
								<p>Every day, close your Studio software and restart it so you can receive software updates.</p>
								<div class="crowd-guidelines-image">
									<img src="//${blapp.config.getHost( "static2" )}/img/bdp/series-1-images/file-setup/digital-building_step-8_update@2x.png" style="width:417px"/>
								</div>
							</li>
						</ol>`
						}
					
					]
				}
			, {
					id: 1
				,	title: 'Design Requirements'
				,	allOpen: false
				, items: [
						{
							id: 0
						,	open: false
						,	question: "Theme"
						,	answer: `<ol>
							<li>
								<p>Make sure your theme is appropriate for a family-friendly audience. Just because we’re targeting adults doesn’t mean we can use themes that are inappropriate for kids. This includes models that depict:</p>
								<ol class="letter-list">
									<li>Politics, political symbols, campaigns, or movements and religious references including symbols, buildings, or people.</li>
									<li>Models cannot be based on modern weapons of war, or life-size replicas of weapons.</li>
									<li>Please note the detailed Content Restrictions in the Terms of Service, Section 7.</li>
								</ol>
								<p>Don’t use Intellectual Property (IP) that belongs to anyone else, including the LEGO Group (e.g., Star Wars™, NINJAGO®, etc.). This includes references to IP in your model description.</p>
							</li>
							<li>
								<p>In order to help us project a vision of a sustainable future, we wish for you to adhere to these additional guidelines:</p>
								<ol class="letter-list">
									<li>Avoid depicting harm to animals (e.g. hunting and trapping; tied-up, caged or dead animals). Fishing is acceptable as well as the usage of any standard element that is used to depict a food element (e.g. part 64648).</li>
									<li>Avoid depicting wild animals in zoos, circuses, aquariums or other situations that are designed for human entertainment. Please only show wild animals in their natural habitats.</li>
									<li>Avoid highlighting fossil fuels like coal, oil, and gas (e.g. depicting refineries, fuel storage or gas stations). It’s acceptable to showcase historical methods of transportation that rely on fossil fuels (e.g. steam locomotives). Modern vehicles need to adhere to this guideline, therefore the propulsion method should be ambiguous if it is not a sustainable power source.</li>
								</ol>
							</li>
							<li>
								<p class="l-margin-bottom--sm">Models may not be based off the following internal LEGO IP:</p>
								<p class="l-margin-top--null">NINJAGO®, Dreamzzz, Friends, Monkie Kid, and the ICONS Modular format.</p>
								<p>Buildings are acceptable to submit to BDP, but they should not reflect the Modular format. If a building looks similar to the design language of the ICONS Modular subtheme (row style building, separating floors, etc) it should use a different base technique. Buildings should also not copy the ICONS Modular baseplate layout design language directly (32x32 baseplate, sidewalk with lamps, Technic connection points). When we review BDP submissions, we will ask “could this model be confused as an ICONS Modular building?”</p>
							</li>
							<li>
								<p>Don’t piggyback on an existing LEGO set by building a model that is an extension or a companion to a specific set in the portfolio. Loose associations are fine, castles look like castle and pirate ships look like pirate ships. BrickHeadz style builds are not allowed.</p>
							</li>	
							<li>
								<p>Models depicting the LEGO Group trademarks and copyright are not allowed. For example, the minifigure and 2x4 brick are protected IP and therefore we cannot allow submissions containing brick-built versions of these parts. You may create brick-built versions of other LEGO parts. Similarly, mosaics and art where the LEGO logo is the main feature are not allowed. The LEGO logo may be used on stickers, but all uses will be reviewed and approved by the LEGO Group before manufacture if selected</p>
								<div class="crowd-resource-box">
									<p class="crowd-resource-box__label"><i class="far fa-link fa-fw l-margin-right--sm"></i>Resources</p>
									<div class="crowd-resource-box__items">
										<a href="${blapp.url2.getCrowdProjectTOSUrl()}" target="_blank" class="btn crowd-resource-box__item">Terms of Service<i class="far fa-square-arrow-up-right l-margin-left--sm"></i></a>
									</div>
								</div>
							</li>
						</ol>
						`
						}
					, {
							id: 1
						,	open: false
						,	question: "Size"
						,	answer: `<ol>
							<li>
								<p>We’ll select a variety of model sizes in each Series, but submissions must contain at least 400 parts and no more than 4,000 parts. <strong>These are strict limits</strong>. To facilitate and encourage a range of set sizes, we’ll pick five submissions across that range to target a Series with an average part count of 2,500.</p>
							</li>
							<li>
								<p>Models should be optimized to use the fewest number of parts possible based on the palette. Don’t manipulate the part count by using a bunch of small parts instead of larger ones.</p>
								<div class="crowd-guidelines-image">
									<img src="//${blapp.config.getHost( "static2" )}/img/bdp/series-1-images/size/size-b@2x.png" style="width:1883px"/>
								</div>
							</li>
							<li>
								<p>While there’s no hard limit on the number of unique part/color combinations, please don’t add unnecessary complexity to your model.</p>
							</li>
						</ol>`
						}
					, {
							id: 2
						,	open: false
						,	question: "Part selection"
						,	answer: `<ol>
							<li>
								<p>Use only parts found in the current official BrickLink Designer Program palette for the intake period you’re submitting for (e.g., ‘BDP Series 6’). <strong>PLEASE NOTE:</strong> The palette check does not need to be 100% error-free as stickers are technically custom parts, and released hinges or moved arms on torsos will all trigger errors</p>
								<div class="crowd-guidelines-image">
									<img src="//${blapp.config.getHost( "static2" )}/img/bdp/series-1-images/part-selection/part-selection-a@2x.png"/>
								</div>
							</li>
							<li>
								<p>Turn the Palette Filter on to show you which parts in an existing model are outside the current palette. In the Step List, click the Filters icon, set the toggle to ON, and select “Unavailable within the selected palette.”</p>
								<div class="crowd-guidelines-image">
									<img src="//${blapp.config.getHost( "static2" )}/img/bdp/series-1-images/file-setup/digital-building_step-2_color-palette@2x.png"/>
								</div>
							</li>
							<li>
								<p>Some assemblies like minifigure torsos must be broken in Studio to be positioned a certain way. Avoid breaking assemblies whenever possible and include info about any broken assemblies in your notes. NOTE: releasing hinges and minifig torsos/legs will show as invalid parts. Please ignore.</p>
							</li>
							<li>
								<p>It’s helpful to use bright colors inside of a model for the sake of contrast in the building instructions. When doing this, use only basic colors. Don’t use rare colors like Flat Silver, Pearl Gold, Trans-Clear, or Dark Red.</p>
							</li>
							<li>
								<p>Balance your colors, part sizes and shapes. Don’t use an excessive number of printed or expensive parts when a simpler solution would also work.</p>
							</li>
							<li>
								<p>Each minifigure head may only be used once in a submission. Skeleton heads do not apply to this rule.</p>
							</li>
						</ol>
						<p>We have deliberately excluded the following types of parts from the palette: Plain string, most electrical components, fabric parts, plastic sheets and printed parts that have a strong association with existing Intellectual Property (IP).</p>`
						}
					, {
							id: 3
						,	open: false
						,	question: "Part usage"
						,	answer: `<ol>
							<li>
								<p>Don’t stack large plates (4x, 6x, 8x) on top of each other or create any other construction that can’t be taken apart easily. An exception to this rule is certain Technic turntables which are assembled this way to function.</p>
								<div class="crowd-guidelines-image">
									<img src="//${blapp.config.getHost( "static2" )}/img/bdp/series-1-images/part-usage/part-usage-a@2x.png" style="width:1469px"/>
								</div>
							</li>
							<li>
								<p>Hoses, outer cables, and other decorative elements must not be used for structural purposes.</p>
							</li>
							<li>
								<p>The 2 x 2 turntable base must not be used as a decoration. It must always be paired with the turntable top.</p>
								<div class="crowd-guidelines-image">
									<img src="//${blapp.config.getHost( "static2" )}/img/bdp/series-1-images/part-usage/part-usage-c@2x.png" style="width:1469px"/>
								</div>
							</li>
							<li>
								<p>Loose parts should be kept to a minimum and should mostly consist of minifigure utensils. Loose parts shouldn’t be poured to fill a space or create an effect (such as water).</p>
							</li>
							<li>
								<p>Make sure the printed surface area of a patterned brick isn’t touching other parts.</p>
								<div class="crowd-guidelines-image">
									<img src="//${blapp.config.getHost( "static2" )}/img/bdp/series-1-images/part-usage/part-usage-e@2x.png" style="width:1469px"/>
								</div>
							</li>
							<li>
								<p>Parts on the edges of a model that are connected by a single stud should be tested physically to make sure they don’t easily fall off.</p>
							</li>
						</ol>`
						}
					, {
							id: 4
						,	open: false
						,	question: "Stability"
						,	answer: `<ol>
							<li>
								<p>The main issue that comes up is the importance of stability in a model. It’s imperative that every measure is taken BEFORE a model is submitted to make sure it’s going to stay together.</p>
							</li>
							<li>
								<p>When a model is being physically built, parts shouldn’t break, collapse or fall off under normal building pressure.</p>
							</li>
							<li>
								<p>Ideally, the building process should consist of parts being pressed downward on a hard, flat surface. Squeezing bricks together between the fingers or hands is discouraged.</p>
							</li>
							<li>
								<p>There must be enough connecting points to keep parts straight and aligned with the natural planes of the model. Drooping walls or difficulty in aligning studs are signs that the model isn’t strong enough.</p>
							</li>
							<li>
								<p>Bricks and plates should overlap whenever possible. Building in stacks may create a certain visual appeal but having a model stay together is more important.</p>
								<div class="crowd-guidelines-image">
									<img src="//${blapp.config.getHost( "static2" )}/img/bdp/series-1-images/stability/stability-e@2x.png" style="width:1469px"/>
								</div>
							</li>
							<li>
								<p>The whole model must be stable enough that it can be picked up with two hands and moved without falling apart.</p>
							</li>
							<li>
								<p>When building with Technic pieces, all sturdy connections must be made using friction pins. Don’t use non-friction pins simply for aesthetic or color reasons.</p>
								<div class="crowd-guidelines-image">
									<img src="//${blapp.config.getHost( "static2" )}/img/bdp/series-1-images/stability/stability-g@2x.png" style="width:1469px"/>
								</div>
							</li>
							<li>
								<p>Don’t overbuild by filling bricks inside the model that aren’t needed for stability.</p>
							</li>
						</ol>`
						}
					, {
							id: 5
						,	open: false
						,	question: "Submodels"
						,	answer: `<p>Submodels are a distinct part of a larger model. Build in submodels instead of adding individual parts to one giant model.</p>
						<ol>
							<li>
								<p>Label your submodels with intuitive names (e.g., chandelier, second floor) so others using your Studio file can easily navigate around your model.</p>
							</li>
							<li>
								<p>There are no limitations to the number of submodels per design.</p>
							</li>
							<li>
								<p>Add parts to the submodels in the way that you’d naturally build. For example, overlap bricks for strength and make sure that each added brick attaches to another brick.</p>
							</li>
							<li>
								<p>Here’s an example of a submodel: Minifigure Knight #1: includes a head, torso, legs, helmet, body armor, sword, shield and horse.</p>
							</li>
						</ol>`
						}
					, {
							id: 6
						,	open: false
						,	question: "Building experience"
						,	answer: `<p>Your model will have to undergo testing and building with physical bricks by the BDP Team. You should aim to make your design as successful as possible in the world of physical building.</p>
						<ol>
							<li>
								<p>Build your model in Studio in the same way you imagine it would be built in real life.</p>
							</li>
							<li>
								<p>Try building your model with physical bricks to test for model safety, stability, and building experience.</p>
							</li>
							<li>
								<p>Separate your model into logical building steps and create instructions. This will help you check for errors which you’ll need to fix BEFORE uploading.</p>
							</li>
							<li>
								<p>Assembling the physical model shouldn’t require specialized building skills or techniques that are learned through years of experience. This includes precision alignment of Technic gears, the easing of Technic elements fixed to an axle, advanced sticker placement techniques and the partial or subjective positioning of elements (e.g., the fractional rotation of 1 x 1 elements).</p>
							</li>
							<li>
								<p>Minifigure construction should take place throughout the building experience and not be confined to the beginning or end of the instructions.</p>
							</li>
						</ol>`
						}
					, {
							id: 7
						,	open: false
						,	question: "Working models"
						,	answer: `<ol>
							<li>
								<p>Technic movement must be smooth and stable. Don’t use excessive sequences of gears or long, winding power flows or anything that bends or stresses the elements.</p>
							</li>
							<li>
								<p>No movement should require special hand alignment or coordination to work. The movement must work reliably when repeated dozens of times and at various speeds.</p>
							</li>
							<li>
								<p>Parts that are designed to function (e.g., propellers, doors, etc.) must function in the model to the complete extent they were designed to function. Hinge plates and hinge bricks are an exception and may be static in the model. Doors must have a door handle on the outside, not the inside. Handles on the inside prevent the door from opening.</p>
								<div class="crowd-guidelines-image">
									<img src="//${blapp.config.getHost( "static2" )}/img/bdp/guidelines/handle-outside.png" style="width:478px"/>
								</div>
							</li>
							<li>
								<p>If combining gears from different families, make sure they mesh correctly without binding or slipping.</p>
							</li>
						</ol>`
						}
					, {
							id: 8
						,	open: false
						,	question: "Stressing the elements"
						,	answer: `<ol>
							<li>
								<p>Studs cannot be inserted into Technic pin holes.</p>
							</li>
							<li>
								<p>Only flexible parts should be bent. Bending any other parts is strictly prohibited.</p>
							</li>
							<li>
								<p>When building horizontally (Studs Not on Top or SNOT), be careful not to interfere with the logo on the stud.</p>
								<div class="crowd-guidelines-image">
									<img src="//${blapp.config.getHost( "static2" )}/img/bdp/series-1-images/stressing-the-elements/stressing-the-elements-c@2x.png" style="width:"/>
								</div>
							</li>
							<li>
								<p>All angles that are closed at both ends must be perfect. The parts must form a legal connection in Studio and must be geometrically sound unless variable-length elements are used to compensate. Designers need to be aware that any angle other than the standard angles of wedges and connectors may present problems and will need to be examined closely. For angled roofs especially, designers are encouraged to leave one end of the roof unattached to avoid an issue with a closed angle.</p>
								<div class="crowd-guidelines-image">
									<img src="//${blapp.config.getHost( "static2" )}/img/bdp/series-1-images/stressing-the-elements/stressing-the-elements-d@2x.png" style="width:"/>
								</div>
							</li>
						</ol>`
						}
					, {
							id: 9
						,	open: false
						,	question: "Minifigures"
						,	answer: `<ol>
							<li>
								<p>There’s a maximum of one minifigure for every 325 parts. See this table for minifigure count limits based on your part count. Skeletons do not count as minifigures.</p>
								<div class="crowd-help__table-container">
									<table class="crowd-help__table">
										<tr>
											<th>Part Count</th>
											<th>Minifigure Limit</th>
										</tr>
										<tr><td>400-650</td><td>2</td></tr>
										<tr><td>651-975</td><td>3</td></tr>
										<tr><td>976-1300</td><td>4</td></tr>
										<tr><td>1301-1625</td><td>5</td></tr>
										<tr><td>1626-1950</td><td>6</td></tr>
										<tr><td>1951-2275</td><td>7</td></tr>
										<tr><td>2276-2600</td><td>8</td></tr>
										<tr><td>2601-2925</td><td>9</td></tr>
										<tr><td>2926-3250</td><td>10</td></tr>
										<tr><td>3251-3575</td><td>11</td></tr>
										<tr><td>3576-3900</td><td>12</td></tr>
										<tr><td>3901-4000</td><td>13</td></tr>
									</table>
								</div>
							</li>
							<li>
								<p>Each minifigure head may only be used once. Skeleton heads do not apply to this rule.</p>
							</li>
							<li>
								<p>Minifigures must be constructed logically with matching torsos, hair, etc. Minifigures will go through a governance process similar to the model itself.</p>
							</li>
							<li>
								<p>If you use a minifigure head with printing on the front and back, hair must be used to cover the reverse side of the head.</p>
							</li>
							<li>
								<p>Minifigures from different eras should not be mixed. For example, please do not use Classic Space minifigures with Modern Space figures in the same model.</p>
							</li>
							<li>
								<p>Minifigures must be complete. You cannot remove head, arms, legs, hips, or hands from minifigure torso.</p>
							</li>
						</ol>`
						}
					, {
							id: 10
						,	open: false
						,	question: "Stickers"
						,	answer: `<ol>
							<li>
								<p>Stickers should only be used where needed.</p>
							</li>
							<li>
								<p>A maximum of one sticker design may be used for every 250 parts. Duplicate stickers don’t count toward the maximum. However, there’s a hard limit of 25 different stickers per model.</p>
							</li>
							<li>
								<p>A single sticker shouldn’t span across multiple parts.</p>
							</li>
							<li>
								<p>Stickers can’t be placed on surfaces that curve in multiple directions.</p>
							</li>
							<li>
								<p>Stickers must be free of intellectual property (IP).</p>
							</li>
							<li>
								<p>Complex designs may need to be simplified as stickers can only contain a certain level of detail.</p>
							</li>
							<li>
								<p>Colors are limited to the official LEGO element colors.</p>
							</li>
							<li>
								<p>Stickers must cover the entire surface on which they are applied, except for stickers with a transparent background.</p>
							</li>
							<li>
								<p>The background of sticker sheets can be white, transparent or mirrored.</p>
							</li>
							<li>
								<p>The artwork on the sticker must not contain any objectionable content, suggestive text or inappropriate images.</p>
							</li>
							<li>
								<p>Confusing configurations of stickers must be avoided (e.g., the same sticker applied to different colored parts, used upside down, etc.).</p>
							</li>
							<li>
								<p>All stickers on a given sheet must be easy to distinguish from one another.</p>
							</li>
							<li>
								<p>Stickers cannot be used on minifigure parts.</p>
							</li>
							<li>
								<p>Please include a PDF, PNG, or JPG/JPEG file of your sticker designs in one file when uploading your submission.</p>
							</li>
							<li>
								<p>Stickers and instructions will be redesigned by a LEGO graphic designer.</p>
							</li>
							<li>
								<p>Whenever possible, use iconography or images instead of text on stickers.</p>
							</li>
							<li>
								<p>Designers may not put their name, username, or identifiable information on stickers.</p>
							</li>
							<li>
								<p>When designing custom parts using the <a href="//www.bricklink.com/v3/studio/partdesigner.page">Studio tool Part Editor</a>, save all custom stickered parts with the part name and color in the name. For example, for a 2x4 tile with a dog bone graphic on the sticker, you could name the part file “2x4 Tile Red Dog Bone.” This will help the design team when reviewing your submission.</p>
							</li>
						</ol>`
						}
					]
			}
			, {
					id: 2
				,	title: 'Building instructions'
				, intro: 'You are responsible for creating building instructions for your design that follow the requirements below. Note: Building instructions will be redesigned by a LEGO graphic designer, so your instructions are for build flow only (not graphical layout).'
				,	allOpen: false
				, items: [
						{
							id: 0
						,	open: false
						,	question: "Step Editor Mode"
						,	answer: `<h3 class="text-color--darkestBlue">Guidelines for the first step</h3>
						<ol>
							<li>
								<p>Start with your foundation elements (e.g., baseplate, vehicle base, etc.).</p>
							</li>
							<li>
								<p>Elements laying side by side with no connection are not allowed.</p>
							</li>
							<li>
								<p>Keep the number of elements to a minimum (1-3).</p>
							</li>
						</ol>
						<h3 class="text-color--darkestBlue">Guidelines for the following steps</h3>
						<ol>
							<li>
								<p>Keep the viewing angle as consistent as possible and limit the number of changes. Any angle changes should be noted for when you enter “Page Design” mode.</p>
							</li>
							<li>
								<p>Only use 5 different elements at most and 10 total elements or less in each step.</p>
							</li>
							<li>
								<p>Don’t build more than thirty studs in any direction unless it’s one full element (e.g., 32x32 base plate, 2x16 plate, etc.).</p>
								<div class="crowd-guidelines-image">
									<img src="//${blapp.config.getHost( "static2" )}/img/bdp/series-1-images/guidelines-for-following-steps/guidelines-for-following-steps-c@2x.png" style="width:1883px"/>
								</div>
							</li>
							<li>
								<p>Avoid placing elements on different levels in the same step (e.g., when building a wall, don’t place elements on the bottom and top of the wall on the same step).</p>
								<div class="crowd-guidelines-image">
									<img src="//${blapp.config.getHost( "static2" )}/img/bdp/series-1-images/guidelines-for-following-steps/guidelines-for-following-steps-d@2x.png" style="width:1883px"/>
								</div>
							</li>
							<li>
								<p>Tall and narrow elements or submodels should be in later steps, not in the beginning or midway point of the instructions.</p>
							</li>
							<li>
								<p>Insert small decorative elements or submodels before enclosing the model. This means if you’re building a house, construct three of the walls then add any furniture or other submodels inside before adding the fourth wall and roof.</p>
								<div class="crowd-guidelines-image crowd-guidelines-image--no-zoom">
									<video class="l-block" controls>
										<source src="//${blapp.config.getHost( "static2" )}/img/bdp/series-1-images/guidelines-for-following-steps/guidelines-for-following-steps-f.webm" type="video/webm" />
									  <source src="//${blapp.config.getHost( "static2" )}/img/bdp/series-1-images/guidelines-for-following-steps/guidelines-for-following-steps-f.mp4" type="video/mp4" />
									  <p>
									    Your browser doesn't support HTML video.
									  </p>
									</video>
								</div>
							</li>
							<li>
								<p>Once an element is placed, it can’t be removed or hidden in future steps.</p>
							</li>
							<li>
								<p>Building techniques must be consistent throughout the model.</p>
							</li>
							<li>
								<p>Sequence your building steps so there’s a logical connection where all elements are attached. In other words, there should be no floating elements in the instructions.</p>
							</li>
						</ol>`
						}
					,	{
							id: 1
						,	open: false
						,	question: "Studio Page Design"
						,	answer: `<h3 class="text-color--darkestBlue">Page design – page setup</h3>
						<ol>
							<li>
								<p>When you’re in ‘Page Design’ mode, ‘Page Setup’ is located on top right corner.</p>
							</li>
							<li>
								<p>Clicking on ‘Page Setup’ will open a new display window.</p>
							</li>
							<li>
								<p>Change the ‘Size’ to ‘Letter’.</p>
							</li>
							<li>
								<p>Set the ‘Margins’ to ‘10’ pixels for all sides (Top, Bottom, Left, and Right).</p>
							</li>
							<li>
								<p>‘Apply’ changes.</p>
							</li>
						</ol>
						<h3 class="text-color--darkestBlue">Page design</h3>
						<ol>
							<li>
								<p>Part Size Scale and Model Size Scale must be the same ratio, (e.g., Part Size Scale: 70%, Model Size Scale: 70%).</p>
							</li>
							<li>
								<p>All elements in the step must be visible.</p>
							</li>
							<li>
								<p>Avoid covering the model with the Parts Window and Step Number.</p>
							</li>
							<li>
								<p>Keep viewing angle changes to a minimum.</p>
							</li>
							<li>
								<p>Insert ‘Flip’ icon when changing viewing angle of 90 degrees or more.</p>
							</li>
							<li>
								<p>The color of the parts highlight feature is set to Red by default. You can change this if another color is more suitable.</p>
							</li>
							<li>
								<p>Insert a Size Guide when using elements that look similar (e.g. Technic Axle 3L and Technic Axle 4L).</p>
							</li>
						</ol>`
						}	
					]
			}
			, {
					id: 3
				,	title: 'Submission upload'
				,	allOpen: false
				, items: [
						{
							id: 0
						,	open: false
						,	question: "Prepare Submission Info Ahead of Time"
						,	answer: `<p>Submissions will open on ${date} at noon Pacific time. You will have to submit the following info in our new upload portal:<p>
						<ol>
							<li>
								<p>Design title</p>
								<ol class="letter-list">
									<li>Design title cannot include LEGO in the title or any other LEGO property.</li>
									<li>Buildings should not include “Modular” in the title.</li>
									<li>Castle and Classic Space models should not include the faction name in the title (e.g. Lion Knight, Wolfpack, Blacktron, etc).</li>
								</ol>
							</li>
							<li>
								<p>Description</p>
								<ol class="letter-list">
									<li>Official LEGO set numbers should not be included in the Model Description.</li>
									<li>No social media links or any other types of links in your product description. There is a field in the upload template to enter a URL to a YouTube video overview of your model and its features if you like.</li>
								</ol>
							</li>
							<li>
								<p>Optional: Internal notes for the BDP Team. We will accept your notes via a word doc, PDF, or within a text box field.</p>
							</li>
							<li>
								<p>Studio submission file</p>
							</li>
							<li>
								<p>High resolution rendered images of your design in multiple angles (up to 10)</p>
								<ol class="letter-list">
									<li>Screenshots of your model in the Studio app are not allowed.</li>
									<li>The first image must be a render, subsequent images can include brick-built photos.</li>
									<li>Renders and photos cannot include prominent use of the LEGO logo (except on the model itself) or of official LEGO sets.</li>
								</ol>
								<div class="crowd-tip-box">
									<p class="crowd-tip-box__label"><i class="fa-light fa-sparkles fa-fw l-margin-right--sm"></i>Tips</p>
									<div class="crowd-tip-box__items">
										<ul>
											<li>Take notes while you’re building so it is fresh in your head.</li>
											<li>If your build uses any floating bricks, make sure you mention it in your notes.</li>
										</ul>
									</div>
								</div>
							</li>
							<li>
								<p>Model images can only include the models included in the design. No reference models should be visible in background, or for scale. This includes “greyed” or “transparent” models in the background.</p>
							</li>
						</ol>`
						}
					,	{
							id: 1
						,	open: false
						,	question: "High resolution images"
						,	answer: `<p className="l-margin-bottom">Use the following settings when rendering your creation:</p>
						<ol>
							<li>
								<p>Render quality minimum: High</p>
							</li>
							<li>
								<p>Ratio 4:3</p>
							</li>
							<li>
								<p>Resolution minimum: 1080 pixels wide.</p>
							</li>
						</ol>`
						}
					]
			}
		];
}


